import { ComponentConfig, FieldLabel } from '@measured/puck';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import { getCurrencyWithSymbol } from '../../../page-builder/utils/formatPrice';
import CustomTooltip from '../../../components/common/tooltip';
import {
  setIsCartLoading,
  setCartData,
} from '../../../page-builder/redux/slices/cartSlice';
import { setCheckoutErrorMessage } from '../../../page-builder/redux/slices/commonSlice';
import { setAvailableShippingMethods } from '../../../page-builder/redux/slices/checkoutSlice';
import './../text-editor/style.scss';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../utils/helper';
import { useSearchParams } from 'react-router-dom';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { AxiosInstance } from 'axios';
import Select from '../../../components/common/select';
import { useCallback, useEffect, useState } from 'react';
import ShipmentProducts, { CartProductsProps } from './shipmentProducts';
import { IProductVariant, IStoreProduct } from '../../interface/storeInterface';
import Border, { IBorderValueProps } from '../../puck/reusable-props/Border';
import { getIsEdit, toolTipInfo } from '../../utils/constants';
import checkoutService from '../../api/checkoutService';
import { marginFields, MarginProps } from '../../puck/reusable-props/margin';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import Toggle from '../../../components/common/toggleSwitchCustom';
import ArrowLogo from '../../../assets/svg/Arrow';
import './style.scss';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
import InputField from '../../../components/common/input-field';
import { imageField } from '../../puck/reusable-props/image';
import { ImageProps, imageProps } from '../../puck/reusable-props/image-props';
import {
  AddItemPayload,
  IAsset,
  CheckoutUpdateItemsPayload,
} from '../../interface/apiServiceInterface';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import {
  LineItem,
  ShippingMethod,
  UpSellData,
} from '../../interface/checkoutInterface';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import WithAccordion from '../customComponents/CustomAccordion';
import { Switch } from '@mui/material';

export type ShipmentUpSellProps = {
  enrollementOption: string;
  imageFile: IAsset;
  isChecboxShouldBeSelected: string;
  selectProductForUpSell: CartProductsProps | null;
  header: string;
  description: string;
  border: IBorderValueProps;
  showImage: boolean;
  hidePrice: boolean;
  customCheckbox: {
    checkboxColor: string;
    checkedBorderColor: string;
    uncheckedBorderColor: string;
    checkboxshape: string;
    checkboxSize: string;
    checkMarkColor: string;
    checkedToggleColor: string;
    uncheckedToggleColor: string;
    toggleSize: string;
    checkMarkSize: string;
  };
  arrow: {
    show: boolean;
    fill: string;
    speed: string;
  };
  background: {
    color: string;
    isInherit: boolean;
  };
  textHideControl: {
    hideHeader: boolean;
    hideDescription: boolean;
  };
} & showComponentProps &
  MarginProps &
  PaddingProps &
  ImageProps;

export const ShipmentUpSell = ({
  useAppSelector,
  useAppDispatch,
  baseService,
}: ReduxSelectorProps & {
  baseService: AxiosInstance;
} & ReduxDispatchProps): ComponentConfig<ShipmentUpSellProps> => {
  return {
    label: (
      <CustomTooltip title="UpSell">
        <span>Shipment UpSell</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      header: {
        ...QuillTextEditor('Header', true, 1).content,
      },
      description: {
        ...QuillTextEditor('Description', true, 2).content,
      },
      textHideControl: {
        type: 'custom',
        label: 'Button Customize',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Text Hide Control">
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Show Header Text">
                      <span>Hide Header</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideHeader}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideHeader: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Show Description Text">
                      <span>Hide Description</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideDescription}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideDescription: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
            </WithAccordion>
          );
        },
      },
      ...marginFields,
      ...paddingFields,
      ...backgroungFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      arrow: {
        type: 'object',
        label: 'Arrow',
        objectFields: {
          show: {
            type: 'radio',
            label: 'Show flashing arrow',
            options: [
              {
                label: 'Yes',
                value: true,
              },
              {
                label: 'No',
                value: false,
              },
            ],
          },
          fill: {
            type: 'custom',
            label: 'Color',
            render: ({ value, onChange, field }) => (
              <ColorPicker
                value={value}
                onChange={onChange}
                label={field.label}
                tooltip={field.label}
              />
            ),
          },
          speed: {
            type: 'custom',
            label: 'Speed',
            render: ({ value, onChange, field }) => (
              <InputField
                value={value}
                field={field}
                onChange={onChange}
                className="mt-3"
              />
            ),
          },
        },
      },
      showImage: {
        type: 'radio',
        label: 'Show Image',
        options: [
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ],
      },
      hidePrice: {
        type: 'radio',
        label: 'Hide Price',
        options: [
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ],
      },
      imageFile: { ...imageField(true, baseService).file },
      ...imageProps([]),
      enrollementOption: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <div>
            <FieldLabel
              label={
                (
                  <CustomTooltip title="EnrollementStyle">
                    <span>Enrollement Style</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }
              el="div"
            />
            <Select
              value={value}
              onChange={e => onChange(e)}
              options={[
                {
                  label: 'Checkbox',
                  value: 'checkbox',
                },
                {
                  label: 'Toggle',
                  value: 'toggle',
                },
              ]}
            />
          </div>
        ),
      },
      customCheckbox: {
        type: 'custom',
        label: 'Custom Checkbox',
        render: ({ value, onChange }) => {
          const options = [
            { label: 'Square', value: 'rounded' },
            { label: 'Circle', value: 'rounded-full' },
          ];
          return (
            <WithAccordion title="Custom Checkbox">
              <>
                <div>
                  <ColorPicker
                    value={value?.checkboxColor || '#000000'}
                    onChange={color =>
                      onChange({ ...(value || {}), checkboxColor: color })
                    }
                    label="Checkbox Color"
                    tooltip="Checkbox Color"
                  />
                </div>
                <div>
                  <ColorPicker
                    value={value?.checkedBorderColor}
                    onChange={color =>
                      onChange({ ...(value || {}), checkedBorderColor: color })
                    }
                    label="Checked Border Color"
                    tooltip="Checked Border Color"
                  />
                </div>
                <div>
                  <ColorPicker
                    value={value?.uncheckedBorderColor}
                    onChange={color =>
                      onChange({
                        ...(value || {}),
                        uncheckedBorderColor: color,
                      })
                    }
                    label="Unchecked Border Color"
                    tooltip="Unchecked Border Color"
                  />
                </div>
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={'Checkbox Shape' as keyof typeof toolTipInfo}>
                          <span>Checkbox Shape</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <div className="w-full p-2">
                      <ToggleButtonGroup
                        value={value?.checkboxshape}
                        exclusive
                        className="w-full"
                        onChange={(_e, selectValue) => {
                          selectValue &&
                            onChange({ ...value, checkboxshape: selectValue });
                        }}>
                        {options.map((option, index: number) => (
                          <ToggleButton
                            key={index}
                            size="small"
                            value={option.value}
                            disableRipple
                            aria-label={option.value}
                            className="flex-1">
                            {option.label}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </div>
                  </FieldLabel>
                </div>
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={'Checkbox Size' as keyof typeof toolTipInfo}>
                          <span>Checkbox Size</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <input
                      type="number"
                      value={value?.checkboxSize || 16}
                      onChange={e =>
                        onChange({
                          ...value,
                          checkboxSize: e.target.value,
                        })
                      }
                      className="w-full p-2 border border-gray-300 rounded"
                      placeholder="Enter checkbox size"
                    />
                  </FieldLabel>
                </div>
                <ColorPicker
                  value={value?.checkMarkColor || '#ffffff'}
                  onChange={color =>
                    onChange({
                      ...(value || {}),
                      checkMarkColor: color,
                    })
                  }
                  label={'Check Mark Color'}
                  tooltip={'Check Mark Color'}
                />
                <ColorPicker
                  value={value?.checkedToggleColor || '#4f46e5'}
                  onChange={color =>
                    onChange({
                      ...(value || {}),
                      checkedToggleColor: color,
                    })
                  }
                  label={'Checked Toggle Color'}
                  tooltip={'Checked Toggle Color'}
                />
                <ColorPicker
                  value={value?.uncheckedToggleColor || '#d1d5db'}
                  onChange={color =>
                    onChange({
                      ...(value || {}),
                      uncheckedToggleColor: color,
                    })
                  }
                  label={'Unchecked Toggle Color'}
                  tooltip={'Unchecked Toggle Color'}
                />
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={'Toggle Size' as keyof typeof toolTipInfo}>
                          <span>Toggle Size</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <input
                      type="number"
                      value={value?.toggleSize || 20}
                      onChange={e =>
                        onChange({
                          ...value,
                          toggleSize: e.target.value,
                        })
                      }
                      className="w-full p-2 border border-gray-300 rounded"
                      placeholder="Enter toggle size"
                    />
                  </FieldLabel>
                </div>
                <div>
                  <FieldLabel
                    label={
                      (
                        <CustomTooltip
                          title={'Check Mark Size' as keyof typeof toolTipInfo}>
                          <span>Check Mark Size</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    el="div"
                    className="w-full">
                    <input
                      type="number"
                      value={value?.checkMarkSize || 16}
                      onChange={e =>
                        onChange({
                          ...value,
                          checkMarkSize: e.target.value,
                        })
                      }
                      className="w-full p-2 border border-gray-300 rounded"
                      placeholder="Enter toggle size"
                    />
                  </FieldLabel>
                </div>
              </>
            </WithAccordion>
          );
        },
      },
      isChecboxShouldBeSelected: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <div>
            <FieldLabel
              label={
                (
                  <CustomTooltip title="Is Checkbox auto Selected">
                    <span>Is Checkbox auto Selected</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }
              el="div"
            />
            <Select
              className=""
              value={value}
              onChange={e => {
                onChange(e);
              }}
              options={[
                {
                  label: 'Yes',
                  value: 'yes',
                },
                {
                  label: 'No',
                  value: 'no',
                },
              ]}
            />
          </div>
        ),
      },
      selectProductForUpSell: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <ShipmentProducts
            baseService={baseService}
            value={value}
            onChange={value => {
              onChange(value);
            }}
            useAppSelector={useAppSelector}
          />
        ),
      },
    },
    defaultProps: {
      textHideControl: {
        hideHeader: false,
        hideDescription: false,
      },
      hidePrice: false,
      showComponent: ['desktop', 'tablet', 'mobile'],
      customCheckbox: {
        checkboxColor: '#4f46e5',
        checkedBorderColor: '#4f46e5',
        uncheckedBorderColor: '#d1d5db',
        checkboxshape: 'rounded',
        checkboxSize: '16',
        checkMarkColor: '#ffffff',
        checkedToggleColor: '#4f46e5',
        uncheckedToggleColor: '#d1d5db',
        toggleSize: '20',
        checkMarkSize: '16',
      },
      enrollementOption: 'checkbox',
      isChecboxShouldBeSelected: 'yes',
      selectProductForUpSell: null,
      border: {
        deviceType: 'desktop',
        borderBottomLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderBottomRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopLeft: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderTopRight: {
          desktop: '0',
          tablet: '0',
          mobile: '0',
        },
        borderWidth: {
          desktop: 1,
          tablet: 1,
          mobile: 1,
        },
        borderStyle: {
          desktop: 'border-solid',
          tablet: 'border-solid',
          mobile: 'border-solid',
        },
        borderColor: {
          desktop: '#000000',
          tablet: '#000000',
          mobile: '#000000',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '10',
          mobile: '0',
          tablet: '0',
        },
      },
      description:
        '<h5 style="line-height:1.5;"><span style="font-size: 16px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor</span></h5>',
      header:
        '<h3 style="line-height:1.5;"><span style="font-size: 20px;">Lorem ipsum dolor sit amet</span></h3>',
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      arrow: {
        show: true,
        fill: '#FF0000',
        speed: '1',
      },
      showImage: true,
      imageFile: {
        storeID: '',
        fileName: 'logo',
        imageUrl: '',
      },
      image: {
        maxWidth: {
          desktop: '100',
          tablet: '100',
          mobile: '100',
        },
        height: {
          desktop: '100',
          tablet: '100',
          mobile: '100',
        },
        deviceType: 'desktop',
      },
    },
    render: ({
      showComponent,
      header,
      description,
      isChecboxShouldBeSelected,
      enrollementOption,
      border,
      selectProductForUpSell,
      margin,
      padding,
      arrow,
      image,
      imageFile,
      showImage,
      hidePrice,
      editMode,
      background,
      customCheckbox,
      textHideControl,
    }) => {
      const dispatch = useAppDispatch();
      const [searchParams] = useSearchParams();
      const { storeData, currentWidth } = useAppSelector(state => state.store);
      const { cartData, isCartLoading } = useAppSelector(state => state.cart);
      const { pageId } = useAppSelector(state => state.checkout);
      const currentDeviceType = getcurrentDeviceType(currentWidth, editMode);
      const [variant, setVariant] = useState<IProductVariant | null>(null);
      const storeID = searchParams.get('storeID') || '';
      const [check, setCheck] = useState<boolean>(
        isChecboxShouldBeSelected == 'yes',
      );

      useEffect(() => {
        if (
          isChecboxShouldBeSelected === 'yes' &&
          showComponent?.includes(currentDeviceType)
        ) {
          handleAdd();
        }
      }, [cartData?.ID]);

      const isProductInCart =
        cartData?.LineItems?.some(item =>
          item?.VariantID?.includes(`${selectProductForUpSell?.variant?.id}`),
        ) || false;

      const handleAdd = useCallback(async () => {
        if (isProductInCart) {
          return;
        }
        if (!cartData?.ID) return;
        dispatch(setIsCartLoading(true));

        const lineItems = [
          {
            Quantity: 1,
            VariantID: `gid://shopify/ProductVariant/${selectProductForUpSell?.variant?.id}`,
          },
        ];

        const payload: AddItemPayload = {
          ID: cartData?.ID,
          LineItems: lineItems,
          ShopID: storeData?.ShopID,
          StoreID: Number(storeData?.StoreID),
          PageID: String(pageId) || '',
        };

        try {
          const res = await checkoutService.checkoutAddItem(payload, {
            preUpsellData: [
              {
                ID:
                  'gid://shopify/Product/' +
                    selectProductForUpSell?.variant?.id || '',
                ImageURL: selectProductForUpSell?.product?.image?.src || '',
                OriginalPrice: selectProductForUpSell?.variant?.price || 0,
                Title: selectProductForUpSell?.product?.title || '',
                Variants: (selectProductForUpSell?.product?.variants || []).map(
                  (variant: IProductVariant) => ({
                    ID: 'gid://shopify/ProductVariant/' + variant.id || '',
                    ImageURL: selectProductForUpSell?.product?.image?.src || '',
                    OriginalPrice: variant.price || 0,
                    Price: variant.price || 0,
                    Title: variant.title || '',
                  }),
                ),
                CurrencyCode: 'USD',
              },
            ] as unknown as UpSellData,
            cartData,
          });
          if (res?.data?.Cart) {
            dispatch(setCartData(res.data.Cart));
            dispatch(
              setAvailableShippingMethods(
                res.data.Cart.AvailableShippingMethods as ShippingMethod[],
              ),
            );
          }
        } catch (error: unknown) {
          if (error instanceof Error) {
            dispatch(setCheckoutErrorMessage(error.message)); // TODO: error message to sentry
          }
        } finally {
          dispatch(setIsCartLoading(false));
        }
      }, [
        cartData,
        storeData?.ShopID,
        storeData?.StoreID,
        selectProductForUpSell?.variant?.id,
      ]);

      const handleRemove = useCallback(async () => {
        dispatch(setIsCartLoading(true));
        const lineItem = cartData?.LineItems.find((item: LineItem) =>
          item.VariantID.includes(`${selectProductForUpSell?.variant?.id}`),
        );

        const lineItems = [
          {
            ID: lineItem?.ID,
            Quantity: 0,
            VariantID: lineItem?.VariantID,
          },
        ];

        const payload = {
          ID: cartData?.ID,
          LineItems: lineItems,
          ShopID: storeData?.ShopID,
          StoreID: Number(storeData?.StoreID),
          PageID: String(pageId) || '',
        };

        try {
          const res = await checkoutService.checkoutUpdateItems(
            payload as CheckoutUpdateItemsPayload,
            cartData,
          );
          dispatch(setCartData(res.data.Cart));
          dispatch(
            setAvailableShippingMethods(
              res.data.Cart.AvailableShippingMethods as ShippingMethod[],
            ),
          );
        } catch (error: unknown) {
          if (error instanceof Error) {
            dispatch(setCheckoutErrorMessage(error?.message)); // TODO: error message to sentry
          }
        } finally {
          dispatch(setIsCartLoading(false));
        }
      }, [
        dispatch,
        cartData,
        storeData?.ShopID,
        storeData?.StoreID,
        selectProductForUpSell?.variant?.id,
      ]);

      const url = imageFile.imageUrl
        ? process.env.REACT_APP_S3_BUCKET_URL + imageFile.imageUrl
        : '';

      const state = useAppSelector(state => state);
      const newDescription = getQuillEditorText(description, state);

      const newHeader = getQuillEditorText(header, state);
      useEffect(() => {
        setCheck(isChecboxShouldBeSelected == 'yes');
      }, [isChecboxShouldBeSelected]);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      const getPages = async () => {
        try {
          if (!storeID) return;
          const res = await checkoutService.getAllStoreProducts(
            +storeID,
            baseService,
            {
              Limit: '100',
              Page: '0',
            },
          );
          if (res?.data?.Result) {
            const product: IStoreProduct = res?.data?.Result?.find(
              (item: IStoreProduct) =>
                item.id === selectProductForUpSell?.product?.id,
            );
            const variant = product?.variants?.find(
              (item: IProductVariant) =>
                item.id === selectProductForUpSell?.variant?.id,
            );
            if (variant) setVariant(variant);
          } else setVariant(null);
        } catch (e) {
          console.error(e, 'error in getPages');
        }
      };

      useEffect(() => {
        if (!getIsEdit()) {
          getPages();
        }
      }, []);

      let price = selectProductForUpSell?.variant?.price;
      if (!getIsEdit() && variant) {
        price = variant.price;
      }
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...getBorderProps(border, currentDeviceType),
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
              }}
              className={`overflow-hidden text-editor-content transition-all ease-in-out flex gap-2 ${border?.borderStyle?.[currentDeviceType]}`}>
              <div className="grid place-items-center">
                <div className="checkbox px-4 flex items-center justify-between">
                  {arrow.show && (
                    <div
                      className="blinkarrow"
                      style={{
                        animation: `blinker ${arrow?.speed}s linear infinite`,
                      }}>
                      <ArrowLogo fill={arrow?.fill} />
                    </div>
                  )}
                  {isCartLoading ? (
                    <div
                      className={`${enrollementOption === 'checkbox' ? 'h-4 w-4' : 'h-6 w-6'} animate-spin rounded-full border-2 border-t-transparent border-blue-500`}></div>
                  ) : enrollementOption === 'checkbox' ? (
                    <input
                      aria-label="State"
                      type="checkbox"
                      className={`mt-1 cursor-pointer ${customCheckbox?.checkboxshape}`}
                      style={{
                        color: customCheckbox?.checkboxColor,
                        width: `${customCheckbox?.checkboxSize}px`,
                        height: `${customCheckbox?.checkboxSize}px`,
                        borderColor: editMode
                          ? check
                            ? customCheckbox?.checkedBorderColor
                            : customCheckbox?.uncheckedBorderColor
                          : isProductInCart
                            ? customCheckbox?.checkedBorderColor
                            : customCheckbox?.uncheckedBorderColor,
                      }}
                      checked={editMode ? check : isProductInCart}
                      onChange={event => {
                        if (event.target.checked) {
                          handleAdd();
                        } else {
                          handleRemove();
                        }
                        setCheck(event.target.checked);
                      }}
                    />
                  ) : (
                    <Toggle
                      checked={editMode ? check : isProductInCart}
                      style={{
                        backgroundColor: check
                          ? customCheckbox?.checkedToggleColor
                          : customCheckbox?.uncheckedToggleColor,
                        color: customCheckbox?.checkMarkColor,
                        width: `${customCheckbox?.toggleSize}px`,
                        height: `${customCheckbox?.toggleSize}px`,
                      }}
                      circleWidth={`${customCheckbox?.checkMarkSize}px`}
                      circleHeight={`${customCheckbox?.checkMarkSize}px`}
                      handleToggle={() => {
                        if (isProductInCart) {
                          handleRemove();
                          setCheck(false);
                        } else if (check) {
                          handleRemove();
                          setCheck(!check);
                        } else {
                          handleAdd();
                          setCheck(!check);
                        }
                      }}
                    />
                  )}
                </div>
                {showImage && (
                  <img
                    src={url}
                    alt={imageFile?.fileName}
                    style={{
                      width: isNaN(+image?.maxWidth[currentDeviceType])
                        ? image?.maxWidth[currentDeviceType]
                        : +image?.maxWidth[currentDeviceType],
                      height: isNaN(+image?.height[currentDeviceType])
                        ? image?.height[currentDeviceType]
                        : +image?.height[currentDeviceType],
                    }}
                    decoding="async"
                  />
                )}
              </div>
              <div className="basis-9/10 flex flex-col gap-1">
                <div>
                  {!textHideControl?.hideHeader && (
                    <div
                      style={{ lineHeight: 1.5 }}
                      dangerouslySetInnerHTML={{
                        __html: newHeader,
                      }}
                    />
                  )}
                  {!hidePrice && Boolean(price) && (
                    <b>
                      {getCurrencyWithSymbol(
                        cartData?.currencyCode || 'USD',
                        String(price),
                      )}
                    </b>
                  )}
                </div>
                {!textHideControl?.hideDescription && (
                  <div
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{
                      __html: newDescription,
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </>
      );
    },
  };
};
